function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import Logos from "segments/desktop/core-components/logos/logos";
import DefaultProps from "./default-props";
import { StyledParagraphAndLogos } from "./paragraph-and-logos.scss";
const ParagraphAndLogos = (props)=>{
    const { fullParagraph, logos, marginBetweenParagraphAndLogos, logosMaxWidth } = props;
    const logosWrapperStyle = useMemo(()=>{
        return {
            marginTop: marginBetweenParagraphAndLogos,
            maxWidth: logosMaxWidth
        };
    }, [
        marginBetweenParagraphAndLogos,
        logosMaxWidth
    ]);
    return /*#__PURE__*/ _jsxs(StyledParagraphAndLogos, {
        className: "paragraph-and-logos",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "paragraph-wrapper",
                children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, fullParagraph))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "logos-wrapper",
                style: logosWrapperStyle,
                children: /*#__PURE__*/ _jsx(Logos, _object_spread({}, logos))
            })
        ]
    });
};
export default ParagraphAndLogos;
ParagraphAndLogos.defaultProps = DefaultProps;
